// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.findarepbase .banner {
    position: relative;
    max-width: 100%;
    height: 419px;
    display: flex;
    flex-direction: column; /* Stack content and search bar vertically */
    justify-content: center; /* Center content vertically */
    align-items: center; /* Center content horizontally */
    overflow: hidden;
    text-align: center; /* Ensure text is centered */
}





.findarepbase .banner-overlay {
    position: relative;
    width: 100%;
    /* Make the banner take up the full width of the page */
    display: flex;
    justify-content: center; /* Center content horizontally */
    align-items: center; /* Center content vertically */
    overflow: hidden;

}


.findarepbase {

    width: 100%;

    justify-content: center; /* Center content horizontally */
    align-items: center; /* Center content vertically */

}


.findarepbase .banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    /* Ensure the image is behind the overlay */
}

.findarepbase .banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.findarepbase .banner-overlay::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.42);
    pointer-events: none;
    z-index: 2;
    /* Ensure the overlay is above the image */
}

.findarepbase .banner-title,
.findarepbase .banner-text {
    position: relative;
    color: var(--Text-alternate, #FFF);
    text-align: center;
    z-index: 3;
    /* Ensure the text is above the overlay and image */
}

.findarepbase .banner-title {
    font-family: Georgia;
    font-size: 50.4px;
    font-weight: 700;
    line-height: 120%;
    /* 60.48px */
}

.findarepbase .searchbar {
    position: relative;

    top: -50px;
    display: flex;
    align-items: center;
    max-width: 1336px;

    width: 90%;
    height: 107px;
    flex-shrink: 0;
    border-radius: 8px;
    background: #FFF;
    box-shadow: 0px 18px 69.8px -5px rgba(0, 0, 0, 0.10);
    z-index: 5;
    margin: 0 auto;  /* This will center the searchbar horizontally */
}

.findarepbase .banner-text {

    font-size: 21px;
    font-weight: 400;
    line-height: 150%;
    /* 31.5px */
}

.findarepbase .banner .content {
    max-width: 1336px;;
    width: 90%; /* Ensures the content can stretch across the available space */
    margin: 0 auto; /* Centers the content horizontally */
    display: flex;
    flex-direction: column;
    align-items: center; /* Centers items horizontally inside content */
    justify-content: center; /* Centers items vertically inside content */
    gap: 25.2px; /* Space between items */
    z-index: 3; /* Ensure it's above the overlay */
    text-align: center; /* Center the text inside content */
}



/* Styles for the main rectangle area */
.findarepbase .rectangle {
    width: 1336px;
    height: 107px;
    flex-shrink: 0;
    border-radius: 8px;
    background: #FFF;
    box-shadow: 0px 18px 69.8px -5px rgba(0, 0, 0, 0.10);
}

/* Styles for the search icon */
.findarepbase .searchicon {
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    left: 29px;
    top: 37px;
    position: absolute;
    z-index: 4;
    /* Ensure the image is behind the overlay */
}

/* Styles for the start typing text area */
.findarepbase .starttyping {
    color: #878787;

    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 30px */
}

/* Styles for the location text */
.findarepbase .location {
    color: #878787;

    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 30px */



}

/* Styles for the vertical rectangle divider */
.findarepbase .vertrectangle {
    width: 2px;
    height: 71px;
    flex-shrink: 0;
    background: #D9D9D9;
    left: 589px;
    top: 18px;
    position: absolute;
}

/* Styles for the location icon */
.findarepbase .locicon {
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    left: 632px;
    top: 37px;
    position: absolute;
}

/* Styles for the button */
.findarepbase .button {
    display: flex;
    width: 172px;
    height: 64px;
    padding: 12px 20px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    left: 1138px;
    top: 22px;
    position: absolute;
    border-radius: 6px;
    background: #458BEA;
    color: var(--Neutral-0, #FFF);

    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    /* 150% */
    letter-spacing: 0.5px;
}

.findarepbase .button:hover {
    background-color: #0056b3;
}



.findarepbase .search-input {
    width: 100%;
    height: 100%;
    padding-left: 70px;
    padding-right: 150px;
    position: absolute;
    box-shadow: none;
    font-size: 20px;
    border: none !important;
    outline: none !important;
}

.findarepbase .search-input::placeholder {
    color: #878787;
    font-size: 20px; /* Match the input text size */
}

.findarepbase .input-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
}

.no-results {
    color: #666;
    font-size: 14px;
    white-space: nowrap;
}

.suggestions-list {
    position: absolute;
    top: 107px;
    width: 100%;
    background: #FFF;
    box-shadow: 0px 18px 69.8px -5px rgba(0, 0, 0, 0.10);
    border-radius: 0 0 8px 8px;
    list-style: none;
    margin: 10px0;
    padding: 0;
    z-index: 10;
}

.suggestions-list li {
    padding: 10px 50px;
    cursor: pointer;
}

.suggestions-list li.selected {
    background: #f0f0f0;
}

.suggestions-list li:hover {
    background: #e0e0e0;
}

.suggestions-list li.no-results {
    color: #666;
    cursor: default;
}

.suggestions-list li.no-results:hover {
    background: transparent;
}

@media (max-width: 768px) {
    .search-input {
        font-size: 16px; /* Prevents iOS from zooming in */
    }
}

.searchbar {
    -webkit-tap-highlight-color: transparent; /* Removes tap highlight on iOS */
}

.search-input:focus {
    outline: none; /* Removes the default focus outline */
    /* Add your custom focus styles here if needed */
}

.error-message {
  color: #ff0000;
  font-size: 14px;
  margin-top: 5px;
}

.no-results {
  color: #666;
  font-size: 14px;
  margin-top: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/FindARepBase/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,aAAa;IACb,sBAAsB,EAAE,4CAA4C;IACpE,uBAAuB,EAAE,8BAA8B;IACvD,mBAAmB,EAAE,gCAAgC;IACrD,gBAAgB;IAChB,kBAAkB,EAAE,4BAA4B;AACpD;;;;;;AAMA;IACI,kBAAkB;IAClB,WAAW;IACX,uDAAuD;IACvD,aAAa;IACb,uBAAuB,EAAE,gCAAgC;IACzD,mBAAmB,EAAE,8BAA8B;IACnD,gBAAgB;;AAEpB;;;AAGA;;IAEI,WAAW;;IAEX,uBAAuB,EAAE,gCAAgC;IACzD,mBAAmB,EAAE,8BAA8B;;AAEvD;;;AAGA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,oBAAoB;IACpB,UAAU;IACV,0CAA0C;AAC9C;;AAEA;;IAEI,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;IAClB,UAAU;IACV,mDAAmD;AACvD;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;;IAElB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,iBAAiB;;IAEjB,UAAU;IACV,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,oDAAoD;IACpD,UAAU;IACV,cAAc,GAAG,gDAAgD;AACrE;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,UAAU,EAAE,+DAA+D;IAC3E,cAAc,EAAE,qCAAqC;IACrD,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,8CAA8C;IACnE,uBAAuB,EAAE,4CAA4C;IACrE,WAAW,EAAE,wBAAwB;IACrC,UAAU,EAAE,kCAAkC;IAC9C,kBAAkB,EAAE,mCAAmC;AAC3D;;;;AAIA,uCAAuC;AACvC;IACI,aAAa;IACb,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,oDAAoD;AACxD;;AAEA,+BAA+B;AAC/B;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,2CAA2C;AAC/C;;AAEA,0CAA0C;AAC1C;IACI,cAAc;;IAEd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;AACb;;AAEA,iCAAiC;AACjC;IACI,cAAc;;IAEd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;;;;AAIb;;AAEA,8CAA8C;AAC9C;IACI,UAAU;IACV,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,kBAAkB;AACtB;;AAEA,iCAAiC;AACjC;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,WAAW;IACX,SAAS;IACT,kBAAkB;AACtB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;;IAE7B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,eAAe,EAAE,8BAA8B;AACnD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,oDAAoD;IACpD,0BAA0B;IAC1B,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,eAAe,EAAE,iCAAiC;IACtD;AACJ;;AAEA;IACI,wCAAwC,EAAE,iCAAiC;AAC/E;;AAEA;IACI,aAAa,EAAE,sCAAsC;IACrD,gDAAgD;AACpD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB","sourcesContent":[".findarepbase .banner {\n    position: relative;\n    max-width: 100%;\n    height: 419px;\n    display: flex;\n    flex-direction: column; /* Stack content and search bar vertically */\n    justify-content: center; /* Center content vertically */\n    align-items: center; /* Center content horizontally */\n    overflow: hidden;\n    text-align: center; /* Ensure text is centered */\n}\n\n\n\n\n\n.findarepbase .banner-overlay {\n    position: relative;\n    width: 100%;\n    /* Make the banner take up the full width of the page */\n    display: flex;\n    justify-content: center; /* Center content horizontally */\n    align-items: center; /* Center content vertically */\n    overflow: hidden;\n\n}\n\n\n.findarepbase {\n\n    width: 100%;\n\n    justify-content: center; /* Center content horizontally */\n    align-items: center; /* Center content vertically */\n\n}\n\n\n.findarepbase .banner-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    /* Ensure the image is behind the overlay */\n}\n\n.findarepbase .banner-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n}\n\n.findarepbase .banner-overlay::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.42);\n    pointer-events: none;\n    z-index: 2;\n    /* Ensure the overlay is above the image */\n}\n\n.findarepbase .banner-title,\n.findarepbase .banner-text {\n    position: relative;\n    color: var(--Text-alternate, #FFF);\n    text-align: center;\n    z-index: 3;\n    /* Ensure the text is above the overlay and image */\n}\n\n.findarepbase .banner-title {\n    font-family: Georgia;\n    font-size: 50.4px;\n    font-weight: 700;\n    line-height: 120%;\n    /* 60.48px */\n}\n\n.findarepbase .searchbar {\n    position: relative;\n\n    top: -50px;\n    display: flex;\n    align-items: center;\n    max-width: 1336px;\n\n    width: 90%;\n    height: 107px;\n    flex-shrink: 0;\n    border-radius: 8px;\n    background: #FFF;\n    box-shadow: 0px 18px 69.8px -5px rgba(0, 0, 0, 0.10);\n    z-index: 5;\n    margin: 0 auto;  /* This will center the searchbar horizontally */\n}\n\n.findarepbase .banner-text {\n\n    font-size: 21px;\n    font-weight: 400;\n    line-height: 150%;\n    /* 31.5px */\n}\n\n.findarepbase .banner .content {\n    max-width: 1336px;;\n    width: 90%; /* Ensures the content can stretch across the available space */\n    margin: 0 auto; /* Centers the content horizontally */\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* Centers items horizontally inside content */\n    justify-content: center; /* Centers items vertically inside content */\n    gap: 25.2px; /* Space between items */\n    z-index: 3; /* Ensure it's above the overlay */\n    text-align: center; /* Center the text inside content */\n}\n\n\n\n/* Styles for the main rectangle area */\n.findarepbase .rectangle {\n    width: 1336px;\n    height: 107px;\n    flex-shrink: 0;\n    border-radius: 8px;\n    background: #FFF;\n    box-shadow: 0px 18px 69.8px -5px rgba(0, 0, 0, 0.10);\n}\n\n/* Styles for the search icon */\n.findarepbase .searchicon {\n    width: 36px;\n    height: 36px;\n    flex-shrink: 0;\n    left: 29px;\n    top: 37px;\n    position: absolute;\n    z-index: 4;\n    /* Ensure the image is behind the overlay */\n}\n\n/* Styles for the start typing text area */\n.findarepbase .starttyping {\n    color: #878787;\n\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    /* 30px */\n}\n\n/* Styles for the location text */\n.findarepbase .location {\n    color: #878787;\n\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    /* 30px */\n\n\n\n}\n\n/* Styles for the vertical rectangle divider */\n.findarepbase .vertrectangle {\n    width: 2px;\n    height: 71px;\n    flex-shrink: 0;\n    background: #D9D9D9;\n    left: 589px;\n    top: 18px;\n    position: absolute;\n}\n\n/* Styles for the location icon */\n.findarepbase .locicon {\n    width: 36px;\n    height: 36px;\n    flex-shrink: 0;\n    left: 632px;\n    top: 37px;\n    position: absolute;\n}\n\n/* Styles for the button */\n.findarepbase .button {\n    display: flex;\n    width: 172px;\n    height: 64px;\n    padding: 12px 20px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n    left: 1138px;\n    top: 22px;\n    position: absolute;\n    border-radius: 6px;\n    background: #458BEA;\n    color: var(--Neutral-0, #FFF);\n\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    /* 150% */\n    letter-spacing: 0.5px;\n}\n\n.findarepbase .button:hover {\n    background-color: #0056b3;\n}\n\n\n\n.findarepbase .search-input {\n    width: 100%;\n    height: 100%;\n    padding-left: 70px;\n    padding-right: 150px;\n    position: absolute;\n    box-shadow: none;\n    font-size: 20px;\n    border: none !important;\n    outline: none !important;\n}\n\n.findarepbase .search-input::placeholder {\n    color: #878787;\n    font-size: 20px; /* Match the input text size */\n}\n\n.findarepbase .input-wrapper {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.no-results {\n    color: #666;\n    font-size: 14px;\n    white-space: nowrap;\n}\n\n.suggestions-list {\n    position: absolute;\n    top: 107px;\n    width: 100%;\n    background: #FFF;\n    box-shadow: 0px 18px 69.8px -5px rgba(0, 0, 0, 0.10);\n    border-radius: 0 0 8px 8px;\n    list-style: none;\n    margin: 10px0;\n    padding: 0;\n    z-index: 10;\n}\n\n.suggestions-list li {\n    padding: 10px 50px;\n    cursor: pointer;\n}\n\n.suggestions-list li.selected {\n    background: #f0f0f0;\n}\n\n.suggestions-list li:hover {\n    background: #e0e0e0;\n}\n\n.suggestions-list li.no-results {\n    color: #666;\n    cursor: default;\n}\n\n.suggestions-list li.no-results:hover {\n    background: transparent;\n}\n\n@media (max-width: 768px) {\n    .search-input {\n        font-size: 16px; /* Prevents iOS from zooming in */\n    }\n}\n\n.searchbar {\n    -webkit-tap-highlight-color: transparent; /* Removes tap highlight on iOS */\n}\n\n.search-input:focus {\n    outline: none; /* Removes the default focus outline */\n    /* Add your custom focus styles here if needed */\n}\n\n.error-message {\n  color: #ff0000;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n.no-results {\n  color: #666;\n  font-size: 14px;\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
